if (!customElements.get('custom-countdown-timer')) {
  // add css
  const style = document.createElement('style');
  style.textContent = `
    .countdown-timer-days.animate,
    .countdown-timer-hours.animate,
    .countdown-timer-minutes.animate,
    .countdown-timer-seconds.animate {
      display: inline-block;
      transform: scale(1.2);
      transition: transform 0.2s ease-in-out;
    }
  `;
  document.head.appendChild(style);

  customElements.define(
    'custom-countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();

        // Attributes
        this.timerType = this.getAttribute('timer-type') || 'duration';
        this.duration = this.getAttribute('timer-duration')
          ? parseInt(this.getAttribute('timer-duration'), 10)
          : 0;
        this.targetDate = this.getAttribute('timer-target')
          ? new Date(this.getAttribute('timer-target'))
          : null;
        this.saveStateKey = this.getAttribute('timer-save-state') || null;
        this.onFinishText = this.getAttribute('timer-on-finish') || null;
        this.enableAnimation = this.getAttribute('timer-animate') === 'true';

        // State
        this.timer = null;

        // Load saved state if available
        if (this.timerType === 'duration' && this.saveStateKey && localStorage.getItem(this.saveStateKey)) {
          const savedState = JSON.parse(localStorage.getItem(this.saveStateKey));
          this.duration = savedState.duration;
        }
      }

      connectedCallback() {
        if (this.timerType === 'target' && !this.targetDate) {
          console.error('Invalid or missing `timer-target` attribute.');
          return;
        }

        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        this.stop(); // Clear any existing timer

        this.timer = setInterval(() => {
          if (this.timerType === 'duration') {
            if (this.duration > 0) {
              this.duration--;
              this.saveState();
              this.updateDisplay();
            } else {
              this.complete();
            }
          } else if (this.timerType === 'target') {
            const now = new Date();
            const remainingTime = Math.floor((this.targetDate - now) / 1000);

            if (remainingTime > 0) {
              this.duration = remainingTime; // Reuse duration logic for display
              this.updateDisplay();
            } else {
              this.complete();
            }
          }
        }, 1000);
      }

      stop() {
        clearInterval(this.timer);
      }

      saveState() {
        if (this.saveStateKey) {
          localStorage.setItem(
            this.saveStateKey,
            JSON.stringify({ duration: this.duration })
          );
        }
      }

      clearState() {
        if (this.saveStateKey) {
          localStorage.removeItem(this.saveStateKey);
        }
      }

      updateDisplay() {
        const days = Math.floor(this.duration / (24 * 60 * 60));
        const hours = Math.floor((this.duration % (24 * 60 * 60)) / (60 * 60));
        const minutes = Math.floor((this.duration % (60 * 60)) / 60);
        const seconds = this.duration % 60;

        this.updateSpan('countdown-timer-days', days);
        this.updateSpan('countdown-timer-hours', hours);
        this.updateSpan('countdown-timer-minutes', minutes);
        this.updateSpan('countdown-timer-seconds', seconds);
      }

      updateSpan(className, value) {
        const span = this.querySelector(`.${className}`);
        if (span && span.innerText !== value.toString().padStart(2, '0')) {
          if (this.enableAnimation) {
            span.classList.add('animate'); // Add animation class if enabled
            setTimeout(() => span.classList.remove('animate'), 200); // Remove after animation
          }
          span.innerText = value.toString().padStart(2, '0'); // Update value
        }
      }

      complete() {
        this.stop();
        this.clearState();

        // Handle `timer-on-finish` text or fallback behavior
        if (this.onFinishText) {
          this.innerHTML = `<div>${this.onFinishText}</div>`;
        } else {
          console.debug('Countdown complete.');
        }
      }
    }
  );
}
